// src/pages/NotFound.jsx
import React from "react";
import notFound from "../../../src/assests/icon/notFound.svg";
const NotFound = () => {
  return (
    <div className=" w-full h-screen text-[#09588D] flex justify-center items-center text-wrap flex-col font-normal  mx-auto">
      <div className="pt-6 w-[800px] overflow-hidden ">
        <img
          src={notFound}
          alt="not-found"
          className="h-full w-full object-none"
        />
      </div>

      <div className="text-[24px] text-gray-500">
        But don't worry --- it might have been moved,renamed,or never existed at
        all.
      </div>
      <a href="/" className="underline">
        Go back to the Homepage
      </a>
    </div>
  );
};

export default NotFound;
